import styled from '@emotion/styled'

export const TextLabel = styled.p`
  padding-bottom: 20px;
`

export const ButtonWrapper = styled.div`
  padding-top: 20px;
`
